import LogUtils from "./LogUtils";

class ValidationUtils {

  constructor() {
    this.TAG = "ValidationUtils";
    this.logUtils = new LogUtils();
  }

  isValidObj(obj) {
    try {
      if (obj === null || obj === undefined || obj === "" || obj === "null" || obj === "undefined") {
        return false;
      }
      return true;
    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Failed on isValid", err);
    }
    return false;
  }

}

export default ValidationUtils;